import React from 'react';
import { ShieldCheck } from 'lucide-react';
import botspotLogo from '../../../assets/botspot_logo_horizontal.png';
import heroBacktestChart from '../../../assets/case-studies/home-hero-backtest-chart.jpg';
import type { AuthFirstDesignProps } from './types';
import './TacticalLedger.css';

export default function TacticalLedger({
  authContent,
  subheading,
  titleId,
}: AuthFirstDesignProps): React.ReactElement {
  return (
    <div className="auth-first-design--tactical-ledger">
      <div className="tactical-ledger__frame">
        <header className="tactical-ledger__masthead">
          <a aria-label="BotSpot home" className="tactical-ledger__brand" href="/">
            <img
              alt="BotSpot by LumiWealth"
              className="tactical-ledger__logo"
              height={429}
              src={botspotLogo}
              width={1385}
            />
          </a>
          <span className="tactical-ledger__masthead-copy">
            botspot.trade
          </span>
        </header>

        <div className="tactical-ledger__grid">
          <div className="tactical-ledger__product-column">
            <div className="tactical-ledger__intro">
              <h1 className="tactical-ledger__title" id={titleId}>
                Turn your trading rules into a bot.
              </h1>
              <div className="tactical-ledger__subheading-container">{subheading}</div>
            </div>

            <figure className="tactical-ledger__evidence">
              <div className="tactical-ledger__evidence-header">
                <div>
                  <strong>Backtest evidence</strong>
                  <span>Historical results stay with each bot revision.</span>
                </div>
                <span>Example run</span>
              </div>
              <div
                aria-label="Example historical backtest equity curve with trade markers"
                className="tactical-ledger__chart"
                role="img"
              >
                <img alt="" src={heroBacktestChart} />
              </div>
              <figcaption>
                <span>Build with AI</span>
                <span>Test on history</span>
                <span>Run with your broker</span>
              </figcaption>
            </figure>

            <div className="tactical-ledger__note-container">
              <ShieldCheck
                aria-hidden="true"
                className="tactical-ledger__note-icon"
                focusable="false"
                size={14}
                strokeWidth={1.8}
              />
              <span className="tactical-ledger__note-text">
                You approve every paper or live run.
              </span>
            </div>
          </div>

          <div className="tactical-ledger__auth-column">
            <div className="tactical-ledger__mobile-context">
              <a aria-label="BotSpot home" className="tactical-ledger__mobile-brand" href="/">
                <img alt="BotSpot by LumiWealth" height={429} src={botspotLogo} width={1385} />
              </a>
              <p>Build custom bots, test them on historical data, and run them with your broker.</p>
            </div>
            <div className="tactical-ledger__auth-body">{authContent}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
